import React from "react";
import { motion } from "framer-motion";

// List of projects
const projects = [
  {
    title: "Rapid Migration",
    description:
      "Framework designed to simplify and automate migration processes, accelerating workload transitions to HPE GreenLake.",
    technologies:
      "GitHub, React.js, Express.js, Django, MySQL, MongoDB, Celery, Redis, Flask, VMware, Nutanix, AWS",
    image: "/assets/img8.avif",
  },
  {
    title: "HPE AI Vision Services",
    description:
      "A suite of vision-based cognitive services, including Facial Recognition, Object Detection, OCR, and Sensitive Data Masking.",
    technologies:
      "Flask, TensorFlow, OpenCV, Tesseract OCR, YOLO, Azure Cloud, Docker, React",
    image: "/assets/img7.avif",
  },
  {
    title: "LLM-based Chatbots",
    description:
      "Developed multiple RAG-based chatbots for automation, including AI-powered document analysis, security insights, and SQL query generation.",
    technologies:
      "Flask, LangChain, VectorDB, Transformer Models, Docker, Azure Cloud",
    image: "/assets/img9.avif",
  },
  {
    title: "AI-Powered Chatbot",
    description:
      "A chatbot built with NLP and deep learning for automated intelligent responses.",
    technologies: "Python, TensorFlow, OpenAI API, React",
    image: "/assets/img11.avif",
  }
];

// Floating Animation
const floatingAnimation = {
  y: [0, 10, 0],
  transition: {
    duration: 5,
    repeat: Infinity,
    repeatType: "mirror" as "mirror", // ✅ Fix for TypeScript
    ease: "easeInOut",
  },
};

const ProjectsSection = () => {
  return (
    <section className="relative min-h-screen  text-white py-20 px-4 sm:px-6 lg:px-8 overflow-hidden flex flex-col items-center">
      {/* Section Title */}
      <div className="text-center mb-16">
        <h2 className="text-4xl sm:text-5xl font-bold text-white bg-clip-text text-transparent">
          Featured Projects
        </h2>
        <p className="text-xl text-gray-400 max-w-3xl mx-auto">
          A showcase of AI-driven applications and cutting-edge technology solutions.
        </p>
      </div>

      {/* Project Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 max-w-6xl">
        {projects.map((project, index) => (
          <motion.div
            key={index}
            className="relative bg-black rounded-2xl border border-gray-800 p-6 shadow-lg overflow-hidden transition-transform duration-500 hover:scale-105"
          >
            {/* Floating Cubes */}
            <motion.div
              className="absolute -top-6 -left-6 w-12 h-12 bg-gray-800 rounded-md transform rotate-45 opacity-50"
              animate={floatingAnimation}
            />
            <motion.div
              className="absolute top-10 right-10 w-16 h-16 bg-gray-800 rounded-md transform rotate-45 opacity-30"
              animate={floatingAnimation}
            />

            {/* Project Image */}
            <div className="relative w-full h-70 mb-4 rounded-lg overflow-hidden">
              <img
                src={project.image}
                alt={project.title}
                className="object-cover w-full h-full"
              />
            </div>

            {/* Project Content */}
            <h3 className="text-2xl font-semibold text-white">{project.title}</h3>
            <p className="text-gray-300 mt-2">{project.description}</p>

            {/* Technologies Used */}
            <p className="text-sm text-gray-400 mt-4">
              <strong className="text-white">Technologies:</strong> {project.technologies}
            </p>

            {/* View More Button */}
            <div className="mt-4">
              <a
                href="#"
                className="text-green-400 hover:text-green-300 transition flex items-center gap-2"
              >
                View Project →
              </a>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default ProjectsSection;


// import React from "react";
// import { motion } from "framer-motion";

// // Dummy Project Data
// const projects = [
//   {
//     title: "AI-Powered Chatbot",
//     description: "A chatbot built with NLP and deep learning for automated responses.",
//     image: "/assets/project1.png",
//   },
//   {
//     title: "E-commerce Platform",
//     description: "A full-stack scalable e-commerce website using Next.js and MongoDB.",
//     image: "/assets/project2.png",
//   },
//   {
//     title: "Cloud Migration Tool",
//     description: "Automated cloud migration tool for seamless server transitions.",
//     image: "/assets/project3.png",
//   },
// ];

// // ✅ Fixed Floating Animation Issue
// const floatingAnimation = {
//   y: [0, 15, 0],
//   transition: {
//     duration: 5,
//     repeat: Infinity,
//     repeatType: "mirror" as "mirror", // ✅ Fix: Correct type
//     ease: "easeInOut",
//   },
// };

// const ProjectsSection = () => {
//   return (
//     <section className="relative min-h-screen bg-black text-white py-20 px-4 sm:px-6 lg:px-8 overflow-hidden flex flex-col items-center">
//       {/* Section Title */}
//       <div className="text-center mb-16">
//         <h2 className="text-4xl sm:text-5xl font-bold bg-gradient-to-r from-white via-gray-400 to-white bg-clip-text text-transparent">
//           Featured Projects
//         </h2>
//         <p className="text-xl text-gray-400 max-w-3xl mx-auto">
//           A showcase of AI-driven applications and cutting-edge technology solutions.
//         </p>
//       </div>

//       {/* Project Cards */}
//       <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 max-w-6xl">
//         {projects.map((project, index) => (
//           <motion.div
//             key={index}
//             className="relative bg-black rounded-2xl border border-gray-800 p-6 shadow-lg overflow-hidden transition-transform duration-500 hover:scale-105"
//           >
//             {/* Floating Cubes with Fixed Animation */}
//             <motion.div
//               className="absolute -top-6 -left-6 w-12 h-12 bg-gray-800 rounded-md transform rotate-45 opacity-50"
//               animate={floatingAnimation}
//             />
//             <motion.div
//               className="absolute top-10 right-10 w-16 h-16 bg-gray-800 rounded-md transform rotate-45 opacity-30"
//               animate={floatingAnimation}
//             />

//             {/* Project Image */}
//             <div className="relative w-full h-40 mb-4 rounded-lg overflow-hidden">
//               <img src={project.image} alt={project.title} className="object-cover w-full h-full" />
//             </div>

//             {/* Project Content */}
//             <h3 className="text-2xl font-semibold text-white">{project.title}</h3>
//             <p className="text-gray-300 mt-2">{project.description}</p>

//             {/* View More Button */}
//             <div className="mt-4">
//               <a
//                 href="#"
//                 className="text-green-400 hover:text-green-300 transition flex items-center gap-2"
//               >
//                 View Project →
//               </a>
//             </div>
//           </motion.div>
//         ))}
//       </div>
//     </section>
//   );
// };

// export default ProjectsSection;